export { default } from './TabUnstyled';
export { default as tabUnstyledClasses } from './tabUnstyledClasses';
export * from './tabUnstyledClasses';
export { default as useTab } from './useTab';
export * from './useTab';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/base/TabUnstyled/index.js
// module id = 536
// module chunks = 1